module.exports = __webpack_public_path__ + "img/place-de-la-cite.83963ba3.svg";